module.exports = __webpack_public_path__ + "static/me-in-oxford-2023-e364dab4018188b41d95a0a0c7d02f3d.jpg";